/**
 *
 * InviteMember
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../DiaogWrap/styles';
import { Column, Row, Wrap } from '../../assets/styledAssets/grid';
import { StyledFormField, StyledLabel } from '../FormField/styles';
import { Input } from '@progress/kendo-react-inputs';

interface IProps {
  onCancel: () => void;
  onSave: (email: string) => void;
}

const InviteMember: FunctionComponent<IProps> = ({ onCancel, onSave }) => {
  const intl = useIntl();
  const [emailValue, setEmailValue] = useState<string>('');
  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.email)}</StyledLabel>
              <StyledFormField>
                <Input
                  onChange={(e) => setEmailValue(e.value)}
                  value={emailValue}
                />
              </StyledFormField>
            </Column>
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(emailValue)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(InviteMember);
